import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/logos/logo-blk.svg")